import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { appUpdateModal, store } from '../atomstore/store';

export const APP_UPDATE_REQUIRED_KEY = 'app_update_required';

const IOS_APP_STORE_ID = '873033151';
const ANDROID_PACKAGE = 'com.footprint.daycareclient';

const IOS_NATIVE_STORE_URL = `itms-apps://apps.apple.com/app/id${IOS_APP_STORE_ID}`;
const IOS_WEB_STORE_URL = `https://apps.apple.com/app/id${IOS_APP_STORE_ID}`;
const ANDROID_NATIVE_STORE_URL = `market://details?id=${ANDROID_PACKAGE}`;
const ANDROID_WEB_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

export const DEFAULT_UPDATE_MESSAGE =
    'It seems you are using an older version. Please update the app to continue.';

const VERSION_OUTDATED_PATTERN = /older version|update to its latest|no longer support this version/i;

export const isAppVersionOutdatedError = (error) => {
    const msg =
        typeof error === 'string'
            ? error
            : error?.error || error?.message || '';
    return VERSION_OUTDATED_PATTERN.test(String(msg));
};

export const markAppUpdateRequired = () => {
    localStorage.setItem(APP_UPDATE_REQUIRED_KEY, '1');
};

export const isAppUpdateRequired = () =>
    localStorage.getItem(APP_UPDATE_REQUIRED_KEY) === '1';

export const clearAppUpdateRequired = () => {
    localStorage.removeItem(APP_UPDATE_REQUIRED_KEY);
};

export const showAppUpdateModal = (message) => {
    markAppUpdateRequired();
    store.set(appUpdateModal, {
        visible: true,
        message: message || DEFAULT_UPDATE_MESSAGE,
    });
};

export const hideAppUpdateModal = () => {
    store.set(appUpdateModal, { visible: false, message: '' });
};

/** Restore blocking update modal on cold start when flag was set earlier. */
export const restoreAppUpdateModalIfNeeded = () => {
    if (!isAppUpdateRequired()) return;
    const current = store.get(appUpdateModal);
    if (current?.visible) return;
    store.set(appUpdateModal, {
        visible: true,
        message: current?.message || DEFAULT_UPDATE_MESSAGE,
    });
};

export const openNativeAppStore = async () => {
    const platform = Capacitor.getPlatform();
    const nativeUrl =
        platform === 'ios'
            ? IOS_NATIVE_STORE_URL
            : platform === 'android'
              ? ANDROID_NATIVE_STORE_URL
              : null;
    const webFallback =
        platform === 'ios' ? IOS_WEB_STORE_URL : ANDROID_WEB_STORE_URL;

    if (Capacitor.isNativePlatform() && nativeUrl) {
        // Deep links open the native store app (itms-apps / market) from the WebView.
        window.location.href = nativeUrl;
        return;
    }

    if (Capacitor.isNativePlatform()) {
        try {
            await Browser.open({ url: webFallback });
            return;
        } catch (e) {
            console.warn('[appUpdate] Browser.open failed:', e);
        }
    }

    window.open(webFallback, '_blank', 'noopener,noreferrer');
};
